import { useAuth } from "@/hooks/use-auth";
import { REINSURANCE_DEPT } from "@/lib/permissions";

export function usePermission(feature: string, permission: string): boolean {
  const { hasPermission } = useAuth();
  return hasPermission(REINSURANCE_DEPT, feature, permission);
}
